import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProgramOnServer } from 'types/program';
import { LinkButton, ButtonSize, ButtonFlavor } from 'ui/components/common/dumb/Button';
import { pathForProgram, pathForProgramImage } from 'ui/components/routing/programHelpers';
import * as styles from './ProgramItem.module.scss';
import { formatDate } from 'util/dateUtil';
import Image from 'ui/components/common/dumb/Image';

interface Props {
  code: ProgramOnServer;
}

const ProgramItem: React.FC<Props> = ({ code }) => {
  const { t } = useTranslation(['myPrograms', 'toast']);

  return (
    <div className={styles.container}>
      <Image src={pathForProgramImage(code.id)} className={styles.thumbnail} alt={code.name} />
      <div className={styles.content}>
        <h3 className={styles.name}>{code.name || t('program.untitled')}</h3>
        <p className={styles.info}>{formatDate(code.created)}</p>
        <div className={styles.actionBox}>
          <LinkButton size={ButtonSize.Small} flavor={ButtonFlavor.Gray} to={pathForProgram(code.id, code.userLogin)}>
            {t(`open`)}
          </LinkButton>
        </div>
      </div>
    </div>
  );
};

export default ProgramItem;
